export default __webpack_public_path__ + "static/articles-lutein-prevantivno-056f8fe10f694f362e89908a60b40d3b.jpg";